import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectMoneda } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select2-cuentaContable', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='moneda'>
          {({ field }) => (
            <SelectMoneda
              {...field}
              id='select-moneda'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
